var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center my-5"},[_c('i',{staticClass:"far fa-spinner-third fa-spin fa-3x text-primary"})])
}]

export { render, staticRenderFns }